import React, { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import './App.css'
import ErrorBoundary from './components/ErrorBoundary'
import Header from './components/Header'
import HomePage from './components/HomePage'
import PollPage from './components/PollPage'
import MenuPollReviewPage from './components/MenuPollReviewPage'
import AdminPage from './components/AdminPage'
import LegalPage from './components/LegalPage'
import ResetPassword from './components/ResetPassword'
import Dashboard from './components/Dashboard'
import ProtectedRoute from './components/ProtectedRoute'
import Footer from './components/Footer'
import { AuthProvider } from './contexts/AuthContext'
import logger from './utils/logger'
import { pageview } from './utils/analytics'

// Component to track route changes for Google Analytics
function RouteTracker() {
  const location = useLocation()

  useEffect(() => {
    // Delay pageview tracking to allow React to update document.title
    // Uses requestAnimationFrame + setTimeout to ensure title is rendered
    const timeoutId = setTimeout(() => {
      requestAnimationFrame(() => {
        pageview(location.pathname + location.search, document.title)
        logger.info('Page view tracked', {
          path: location.pathname,
          title: document.title
        })
      })
    }, 0)

    return () => clearTimeout(timeoutId)
  }, [location])

  return null
}

function App() {
  useEffect(() => {
    logger.info('App initialized')
  }, [])

  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 3000,
                style: {
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  border: '1px solid var(--border-color)',
                },
                success: {
                  iconTheme: {
                    primary: 'var(--success-color)',
                    secondary: 'var(--bg-secondary)',
                  },
                },
                error: {
                  iconTheme: {
                    primary: 'var(--error-color)',
                    secondary: 'var(--bg-secondary)',
                  },
                },
              }}
            />
            <Header />
            <RouteTracker />
            <main className="container" style={{ flex: 1, width: '100%' }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/poll/:id" element={<PollPage />} />
                <Route path="/review/:id" element={<MenuPollReviewPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/legal" element={<LegalPage />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App

